import React from 'react';
import { connect } from "react-redux";
import {   
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    ModalFooter,
    Text,
    FormControl,
    FormLabel,
    Input,
    Button
} from '@chakra-ui/react';

import { ReduxState } from "../../store/state";
import { Location as ILocation, LocationFlow, LocationModals } from '../../store/location/types';
import { setUserLocationInputs } from '../../store/location/actions';
import { 
 toggleCreateLocationModal 
} from '../../store/location/actions';
import MapPicker from '../global/location/MapPicker';
import { 
  asyncLocationCreate, autoLocateDevice, getLocationAddress, fetchUserLocations 
} from '../../store/location/initiators';
import { User } from '../../store/user/types';
import { MdLocationPin } from 'react-icons/md';

interface CreateLocationModalProps {
  toggleCreateLocationModal: () => void;
  setUserLocationInputs: (inputs: LocationFlow) => void;
  asyncLocationCreate: (newLocation: any, makeDefault: boolean) => void;
  autoLocateDevice: () => void;
  getLocationAddress: (latitude: number, longitude: number) => void;
  fetchUserLocations: (userId: string) => void;
  locationModals: LocationModals;
  selectedLocation: ILocation | null;
  locationFlow: LocationFlow;
  user: User | null;
}

class CreateLocationModal extends React.Component<CreateLocationModalProps> {
  componentDidMount = () => {
    if (this.props.selectedLocation) {
      this.props.setUserLocationInputs({
        ...this.props.locationFlow,
        name: 'Default',
        mode: 'create',
      })
      this.props.autoLocateDevice()
    }
  }

  renderDescription = () => {
    const { address, latitude, longitude, name } = this.props.locationFlow;
    return <Text pb={2}>{address ? `${name}: ${address}` : null}</Text>
  }

  renderNameForm = () => {
    return (
      <FormControl flex={1} pb={2}>
        <FormLabel>Location Name *</FormLabel>
        <Input 
          id="locationName" 
          placeholder="Type a name" 
          style={{ borderRadius: 25}}
          value={this.props.locationFlow.name}
          onChange={(e) => this.props.setUserLocationInputs({
            ...this.props.locationFlow,
            mode: 'edit',
            name: e.target.value
          })}
        />
      </FormControl>  
    );
  }

  renderInstructionsForm = () => {
    return (
      <FormControl flex={1} pb={2}>
        <FormLabel>Instruction (optional)</FormLabel>
        <Input 
          id="locationInstruction" 
          placeholder="Instruction (optional)" 
          style={{ borderRadius: 25}}
          value={this.props.locationFlow.instruction ? this.props.locationFlow.instruction : ''}
          onChange={(e) => this.props.setUserLocationInputs({
            ...this.props.locationFlow,
            mode: 'edit',
            instruction: e.target.value
          })}
        />
      </FormControl>  
    );
  }

  render() {
    const { locationFlow } = this.props;
    var { latitude, longitude, name, address, instruction } = locationFlow;
    let _id = '';
    if (this.props.selectedLocation && this.props.selectedLocation._id) {
      _id = this.props.selectedLocation._id
    }
    return (
      <Modal isOpen={this.props.locationModals.createLocationModalOpen} onClose={() => {
        this.props.toggleCreateLocationModal()
      }} size={'4xl'}>
        <ModalOverlay />
        <ModalContent style={{ borderRadius: 25 }}>
          <ModalHeader>Add Location</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={10}>
            {this.renderNameForm()}
            {this.renderInstructionsForm()}
            {this.renderDescription()}
            <MapPicker 
              initialLatitude={latitude ? latitude : 18}
              initialLongitude={longitude ? longitude : -77 }
              onLocationSelect={this.props.getLocationAddress}
              autoLocateDevice={() => this.props.autoLocateDevice()}
              mapCoordinates={{ latitude, longitude }}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                this.props.toggleCreateLocationModal()
              }}
              variant="ghost"
              mr="5%"
              borderRadius={20}
            >
              Back
            </Button>
            <Button
              colorScheme="green"
              variant="outline"
              borderRadius={20}
              onClick={() => {
                if (this.props.user && latitude && longitude) {
                  const userId = this.props.user._id
                  const { name, address, instruction } = this.props.locationFlow
                  this.props.asyncLocationCreate({ 
                    name, address, instruction, 
                    default: true, 
                    deleted: false,
                    userId,
                    latitude,
                    longitude
                  }, true)
                  this.props.fetchUserLocations(userId)
                  this.props.toggleCreateLocationModal()
                }

              }}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
}

const mapStateToProps = (state: ReduxState) => {
  const { locationModals, selectedLocation, locationFlow } = state.location;
  const { user } = state.user;
  return { locationModals, selectedLocation, locationFlow, user };
};

export default connect(mapStateToProps, {
toggleCreateLocationModal,
setUserLocationInputs,
asyncLocationCreate,
autoLocateDevice,
getLocationAddress,
fetchUserLocations
})(CreateLocationModal);
